<script lang="ts" setup>
  import { Banner, BaseButton, TwoLineSquare, Text } from '@bt/design-system'
  import renderRichText from '~/utils/renderSbRichText'
  const { isMobile } = useBreakpoints()
  const { locale, t } = useI18n()

  interface IBanner {
    text: string
    icon?: string
    title?: string
    day?: number
    monthYear?: string
    slug?: string
  }

  const emit = defineEmits(['openEvent'])

  const openEvent = (slug: string, event) => {
    if (event.ctrlKey || event.shiftKey) return
    emit('openEvent', slug)
  }

  const getEventUrl = (slug: string) => {
    return `/${locale.value}/${t('media-room.slug')}?press=${slug}`
  }

  const { blok } = defineProps<{
    blok: IBanner
  }>()
</script>

<template>
  <div class="banner-wrapper">
    <Banner
      :text="renderRichText(blok.text)"
      :title="blok.title"
      full-text
      :full-title="isMobile"
      :mobile-direction="isMobile ? 'column' : 'row'"
      bg="ghost"
      wideSpacing
    >
      <template #illustration>
        <template v-if="isMobile">
          <Text
            :text="blok?.day + ' ' + blok?.monthYear"
            type="body1"
          />
        </template>
        <template v-else>
          <TwoLineSquare
            v-if="blok.day || blok.monthYear"
            :subtitle="blok.monthYear"
            :title="blok.day"
          />
        </template>
      </template>
      <template #action="{ className }">
        <NuxtLink
          :to="getEventUrl(blok.slug)"
          class="link-wrap"
        >
          <BaseButton
            block-type="auto"
            :class="className"
            :is-block="true"
            color="ghost"
            :title="$t('buttons.read-more')"
            @click="openEvent(blok.slug, $event)"
          />
        </NuxtLink>
      </template>
    </Banner>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/styles/common.scss';

  .banner-wrapper {
    padding-bottom: rem(39);
    margin-bottom: rem(40);
    border-bottom: 1px solid $divider;
  }

  .link-wrap {
    width: 100%;

    @include tablet-up {
      max-width: max-content;
    }

    button {
      width: 100%;
    }
  }
</style>
